import { render, staticRenderFns } from "./AttestationQueuePanel.vue?vue&type=template&id=5e3cba74&scoped=true&"
import script from "./AttestationQueuePanel.vue?vue&type=script&lang=js&"
export * from "./AttestationQueuePanel.vue?vue&type=script&lang=js&"
import style0 from "./AttestationQueuePanel.vue?vue&type=style&index=0&id=5e3cba74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3cba74",
  null
  
)

export default component.exports